var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorld = function SvgWorld(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    x: 2,
    y: 2,
    fill: "#E2FFEA",
    rx: 18
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    x: 2,
    y: 2,
    stroke: "#F4FFF7",
    strokeWidth: 4,
    rx: 18
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#51C394",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.571,
    clipPath: "url(#world_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.662 20.727a9.428 9.428 0 1 1-9.429-9.428m-9.428 9.428h10.879"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.234 11.299a16.28 16.28 0 0 0-3.627 9.428 16.27 16.27 0 0 0 3.627 9.429 16.3 16.3 0 0 0 3.366-7.252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.635 15.238c-.55-.094-.55-.886 0-.982a4.99 4.99 0 0 0 4.021-3.85l.032-.152c.12-.546.896-.55 1.021-.005l.04.178a5.02 5.02 0 0 0 4.032 3.826c.553.096.553.893 0 .99a5.02 5.02 0 0 0-4.032 3.826l-.04.176c-.125.544-.9.54-1.021-.004l-.032-.151a4.99 4.99 0 0 0-4.02-3.852"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "world_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 9h22v22H9z"
  })))));
};
export default SvgWorld;